import { ViewController, View, ChannelSwitchEvent } from "@gaming/srvg-classes-core";
import { TimelineOverlayContainerView } from "../../View/TimelineOverlayContainerView";
import { StatisticsGalleryViewController } from "./StatisticsGalleryViewController";
import { SettlementGalleryViewController } from "./SettlementGalleryViewController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

/**
 * Controls the timeline-controlled overlays and the various widgets inside them.
 */
export class TimelineOverlayContainerViewController extends ViewController {

    timelineOverlayContainerView: TimelineOverlayContainerView;
    statisticsGalleryViewController: StatisticsGalleryViewController;
    settlementGalleryViewController: SettlementGalleryViewController;

    /**
     * Flag for storing if the view should be visible.
     * In Vf, this flag will determine if the timeline overlay should be shown after the manual overlay is hidden.
     */
    shouldBeShown: boolean;
    /**
     * If set to false, the view will not be shown, even if it should be.
     * In VF, this flag will be set when a manual overlay is shown and cleared when it is hidden again.
     */
    mayBeShown: boolean;
    /**
     * If set to true, we can hide the post_match overlay, otherwise is shall be displayed.
     * It helps to decide, if the post_match overlay shall be shown or not in special cases.
     */
    itsPost: boolean;
    /**
     * object with all overlay information, elements, data etc.
     */
    protected overlays: any;
    /**
     * time for fadings and so on, in ms
     */
    animationTime: number;
    /**
     * timeout for overlay delay
     */
    protected delayTimeout: ReturnType<typeof setTimeout>;
    /**
     * Used for automatically closing the overlay container
     */
    protected durationTimeout: ReturnType<typeof setTimeout>;

    currentChannel;
    currentChunk;

    /**
     *
     */
    constructor( options ) {
        options = options ||{};
        options.view = options.timelineOverlayContainerView || null;
        options.name = options.name || 'timelineOverlayContainerViewController';
        super( options );
        this.timelineOverlayContainerView = options.timelineOverlayContainerView || null;
        this.shouldBeShown = false;
        this.mayBeShown = true;
        this.itsPost = false;

        this.animationTime = 400;

        this.delayTimeout = null;
        this.durationTimeout = null;

        this.statisticsGalleryViewController = this.addChildViewController( new StatisticsGalleryViewController( { galleryView: this.timelineOverlayContainerView.preMatchOverlay.teamStatisticsGalleryView } ) );
        this.settlementGalleryViewController = this.addChildViewController( new SettlementGalleryViewController( { galleryView: this.timelineOverlayContainerView.postMatchOverlay.galleryView } ) );

        // add dynamic stuff to the config
        srvg.overlay_timings.post_match.delay = srvg.timelineSubPhases.celebration.length;
        srvg.overlay_timings.pre_match.delay = srvg.timelineSubPhases.logo_clash.length;

        this.currentChannel = null;
        this.currentChunk = null;
    }

    /**
     * Shows the given overlay and installs a timeout to close it again.
     */
    private showOverlay( overlayView: View, offset: number, delay: number, duration: number, phase_length: number ) {
        this.log( 'TIMELINE OVERLAY ON', overlayView.name );
        this.timelineOverlayContainerView.showOnlySubView( overlayView );

        // configure the progressView of the overlay, if it has one
        if( overlayView['progressView'] ) {
            var currentPosition = offset;
            if( delay ) {
                if( offset > delay ) {
                    currentPosition = offset-delay;
                }
                else {
                    currentPosition = 0;
                }
            }
            this.log( 'starting countdown @', currentPosition, '/', duration );
            overlayView['progressView'].startCountdown( duration, currentPosition );
        }

        this.shouldBeShown = true;
        if( this.mayBeShown && ! this.timelineOverlayContainerView.isShown ) {
            this.timelineOverlayContainerView.show( true );
        }

        // automatically close the overlay at the end of the duration or the end of the phase
        var durationLeft = duration;
        if( durationLeft > phase_length-offset ) {
            durationLeft = phase_length-offset;
        }
        var that = this;
        this.durationTimeout = setTimeout( function () {
                that.durationTimeout = null;
                that.log( 'TIMELINE OVERLAY OFF because of timeout' );
                that.shouldBeShown = false;
                if( that.timelineOverlayContainerView.isShown ) {
                    that.timelineOverlayContainerView.hide( true );
                }
            },
            durationLeft*1000 );

        // FIXME - this is a workaround for the buggy livetable in the overlay
        if (app.leagueView && $('#prematchLiveGroupTableWidgetOverlay').view().widget.status == "INITIALIZED") {
            $('#prematchLiveGroupTableWidgetOverlay').view().widget.api.relayout()
        }
    }

    // ************************** Event handlers **************************

    /**
     *
     */
    handleChannelSwitchEvent( event:ChannelSwitchEvent ) {
        var currentPhaseId = app.timelineController.lastTimelineData.channels[app.timeline.currentChannel].phase_id;

        // Overtime and penalty_shootout can on one channel can be concurrent with post_match
        // on a different channel. We need to turn the overlay container on or off when switching
        // channels during these phases. We have to avoid that the overlay container displays too early because
        // the data-phase-name switch from match to post_match is before the post_match_overlay displays. That's
        // why we have to call the postMatchOverlay to show up instead of the timelineOverlayContainerView itself.
        // Additionally we have to avoid that the timelineOverlayContainerView shows up for too long. That's why
        // the little helper variable itsPost is set to true as a signal for handlePhaseChangeEvent.
        if( currentPhaseId == srvg.timelinePhases.post_match.id && this.mayBeShown == true ){
            this.itsPost = true;
            this.timelineOverlayContainerView.postMatchOverlay.show(true);
        }
        else if(
            (srvg.timelinePhases.overtime && currentPhaseId == srvg.timelinePhases.overtime.id) ||
            (srvg.timelinePhases.penalty_shootout && currentPhaseId == srvg.timelinePhases.penalty_shootout.id)
        ) {
            this.timelineOverlayContainerView.hide();
        }

        if(typeof event.newChannel !== "undefined"){
            this.currentChannel = event.newChannel;
        }else{
            this.currentChannel = app.timeline.currentChannel;
        }
        this.setCurrentWidgetGroups();
    }
    /**
     *
     */
    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        // This if avoids that the timelineOverlayContainerView shows up for too long in case of the special case
        // from handleChannelSwitchEvent. Before we hide the overlay, we have to ensure that a overlay is shown,
        // the post_match overlay shouldn't be longer displayed and post_match phase is over.
        if( this.timelineOverlayContainerView.isShown &&
            (this.itsPost == true) &&
            (app.timelineController.lastTimelineData.channels[app.timeline.currentChannel].phase_id != srvg.timelinePhases.post_match.id) ) {
            this.timelineOverlayContainerView.hide( true );
            this.itsPost = false;
        }

        //console.log( new Date(), event.phase.name );
        this.log( event.phase.name );

        // competition stage group stage/league stage with pre match overlay and switch widgets to right group
        if(event.chunk && event.chunk.matches){
            this.currentChunk =  event.chunk;
            if (this.currentChannel === null && typeof event.channel !== "undefined"){
                this.currentChannel = event.channel;}
        }
        this.setCurrentWidgetGroups();

        // Add data attributes for the current competition stage and the current phase name to the overlay view.
        // Avoiding css classes switch, because you have to remove every time css classes and add them again etc.
        this.timelineOverlayContainerView.$domNode
            .attr('data-competition-stage', event.chunk.competitionStageType)
            .attr('data-phase-name', event.phase.name);

        // calculate offset for later entry point ( overlays which have a delay )
        var offset = event.serverDatetime - event.phase.start;
        var phase_length = event.phase.end-event.phase.start;

        // If a timeout for a delayed showing was set before, remove it. Shouldn't happen.
        if (this.delayTimeout !== null){
            clearTimeout( this.delayTimeout );
            this.delayTimeout = null;
        }

        // If a timeout for a automatic hiding was set before, remove it. Important, otherwise an old overlay might
        // hide the new one due to a race condition.
        if (this.durationTimeout !== null){
            clearTimeout( this.durationTimeout );
            this.durationTimeout = null;
        }

        // Look for overlay configuration
        var configEntry = srvg.overlay_timings[event.phase.name];
        if( configEntry ) {
            // Use config settings to show overlay
            var overlayView = this.timelineOverlayContainerView.findSubViewBySelector( configEntry.overlay );
            if( overlayView ) {
                // How long do we have to wait to show the overlay?
                var delay = configEntry.delay-offset;
                if( delay < 0 ){
                    delay = 0;
                }
                // How long should the overlay be shown
                var duration = configEntry.duration || phase_length;
                if( duration > phase_length-delay ) {
                    duration = phase_length-delay;
                }

                if( delay && delay > offset ) {
                    // Show later
                    this.log( 'Showing timeline overlay in', delay-offset );
                    var that = this;
                    this.delayTimeout = setTimeout(function() {
                        that.delayTimeout = null;
                        that.showOverlay( overlayView, offset, delay, duration, phase_length );
                    }, (delay-offset)*1000 );
                }
                else {
                    // Show now
                    this.log( 'Showing timeline overlay now' );
                    this.showOverlay( overlayView, offset, delay, duration, phase_length );
                }
            }
        }
        else {
            // Hide Overlay container, because no overlay config was found for this phase.
            if( this.timelineOverlayContainerView.isShown ) {
                // Hide container. Should rarely be executed because overlays usually close themselves
                this.log( 'TIMELINE OVERLAY OFF because in this phase, there should be no overlay' );
                this.timelineOverlayContainerView.hide( true );
            }
            this.shouldBeShown = false;
        }
    }

    getCurrentGroup() {
        if (this.currentChannel !== null && this.currentChunk != null) {
            if (this.currentChunk.competitionStageType === "league" && this.currentChunk.matches) {
                let findCurrentMatch = this.currentChunk.matches[this.currentChannel];
                if (findCurrentMatch && findCurrentMatch.matchset && findCurrentMatch.matchset.competitionStage && findCurrentMatch.matchset.competitionStage.nr) {
                    let findCompetitionStageNr = findCurrentMatch.matchset.competitionStage.nr;
                    return String.fromCharCode('A'.charCodeAt(0) + findCompetitionStageNr - 1);
                }
            }
        }

        return null;
    }

    setCurrentWidgetGroups() {
        let group = this.getCurrentGroup();
        // set widgets
        if(this.timelineOverlayContainerView.preMatchOverlay.groupResultWidget){
            this.timelineOverlayContainerView.preMatchOverlay.groupResultWidget.setGroup(group);
        }
        if(this.timelineOverlayContainerView.preMatchOverlay.livetableWidget){
            this.timelineOverlayContainerView.preMatchOverlay.livetableWidget.setGroup(group);
        }
    }
}
